import transactions from "./transactions";
import deposit from "./deposit";
import withdrawal from "./withdrawal";
import payId from "./payId";

const financeModule = {
  namespaced: true,
  modules: {
    transactions,
    deposit,
    withdrawal,
    payId,
  },
};

export default financeModule;
